import React from 'react'
import { Card, withStyles } from '@zn-material-ui'
import Store from 'store'
import MoreButton from '@components/MoreButton'
import ListData from '@components/LearnRecords'
import styles from '../styles/RecordList'
import { transform } from '@utils/intl_lang'
const HOUR = 1000 * 60 * 60
const StudyRecords = (props: any) => {
  const { classes, learnRecordView = {}, learnRecordList = [] } = props
  const hasOrg = Store.get('hasOrg') || false
  return (
    <Card className={classes.card}>
      {/* 学习足迹 */}
      <div className={classes.title}>{transform('learning_footprint')}</div>
      <ul className={classes.detail}>
        <li>
          <span className={classes.numbers}>
            {`${((learnRecordView.duration || 0) / HOUR).toFixed(1)}h` ||
              '0.0h'}
          </span>
          {/* 学习时长 */}
          <span>{transform('learn_time')}</span>
        </li>
        <li>
          <span className={classes.numbers}>
            {learnRecordView.studyNum || 0}
          </span>
          {/* 学习次数 */}
          <span>{transform('learn_num')}</span>
        </li>
        <li>
          <span className={classes.numbers}>
            {learnRecordView.finishCourseCnt || 0}
          </span>
          {/* 已学课程 */}
          <span>{transform('learn_course')}</span>
        </li>
      </ul>
      {hasOrg && (
        <>
          <ListData
            learnList={learnRecordList}
            classes={classes}
            limitNumber={3}
            isLine={true}
          />
          <MoreButton
            style={{
              background: 'none',
              marginBottom: 0,
            }}
            onFetch={props.fetchMore}
            // "查看更多学习足迹"
            abledText={transform('home_more_learn_footprint')}
            // zn-i18n-disable-next-line
            data-event-category="01Web-智门户首页"
            // zn-i18n-disable-next-line
            data-event-label="0112Web-首页-查看更多"
            // zn-i18n-disable-next-line
            data-event-mapkv={JSON.stringify({ from: '01Web-智门户首页' })}
          />
        </>
      )}
    </Card>
  )
}
export default withStyles(styles)(StudyRecords)
